var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInfoCircleRedFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Info Circle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 8.99935C0.666748 4.40018 4.40008 0.666016 9.00008 0.666016C13.6084 0.666016 17.3334 4.40018 17.3334 8.99935C17.3334 13.6002 13.6084 17.3327 9.00008 17.3327C4.40008 17.3327 0.666748 13.6002 0.666748 8.99935ZM8.26675 5.84102C8.26675 5.44185 8.60008 5.10768 9.00008 5.10768C9.40008 5.10768 9.72508 5.44185 9.72508 5.84102V9.52435C9.72508 9.92518 9.40008 10.2493 9.00008 10.2493C8.60008 10.2493 8.26675 9.92518 8.26675 9.52435V5.84102ZM9.00842 12.9002C8.60008 12.9002 8.27508 12.5668 8.27508 12.1668C8.27508 11.7668 8.60008 11.4418 9.00008 11.4418C9.40841 11.4418 9.73341 11.7668 9.73341 12.1668C9.73341 12.5668 9.40841 12.9002 9.00842 12.9002Z",
    fill: "#B32306"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoCircleRedFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/InfoCircleRedFilled.4f443f56.svg";
export { ForwardRef as ReactComponent };